import {observable, action, computed} from 'mobx';
import {paths} from '../App';


let instance = null

export class Cache {
  @observable affiliateProducts = {};

  static clear(){
    instance.affiliateProducts = {};
  }
}

if(!instance){
  instance = new Cache
}


export default instance;